import { Box, Button, Container, IconButton, Typography, CircularProgress, List, Tooltip, Divider, Link } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Axios from '../../../config/axios'
import { UrlConstant } from '../../../commom/UrlConstant'
import SpinWheel from './SpinWheel'
import bgimage from '../../../style/images/cardbackground.png'
import spinwheelbg from "../../../style/images/spinwheelbg.png"
import card from '../../../style/images/referfriendcardbg.png'
import copy from '../../../style/images/copy.png'
import { usePriceFormatter } from '../../../hooks'
import Successpopup from '../SharedComponent/Successpopup'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
interface ReferralDataResponse {
    status: boolean;
    data: {
        referral_code: string;
        referrals_count: number;
        redeemUrl: string;
        // couponList: {
        //     code: string;
        //     value: number;
        //     endsAt: string;
        //     isRedeem: boolean;
        // }[];
        available_spins: number;
        total_balance_earn_on_spin: number;
        minSpinValue: number;
        maxSpinValue: number;
    };
    message: string;
}

interface DepositHistoryItem {
    transactionId: string;
    amount: number;
    currency: string;
    status: 'PENDING' | 'COMPLETED' | 'REJECTED' | 'CANCELLED';
    requestedAt: string;
    completedAt: string | null;
    rejectedAt: string | null;
    rejectionReason: string | null;
}

function ReferFriend() {
    const navigation = useNavigate();
    const location = useLocation();
    const SpinWheelAmount = location.state;
    const [loading, setLoading] = useState(true);
    const [referralData, setReferralData] = useState<ReferralDataResponse["data"] | null>(null);
    const [availableSpins, setAvailableSpins] = useState<number>(0); // Add state for available spins
    const source = location.state?.source || 'dashboard';  // Default to 'dashboard' if not passed
    const breadcrumb = source === 'dashboard' ? 'Dashboard / Refer Friend' : 'More Options / Refer Friend';
    const [copiedCoupon, setCopiedCoupon] = useState<string | null>(null);
    const [depositHistory, setDepositHistory] = useState<DepositHistoryItem[]>([]);
    const [showPopup, setShowPopup] = useState(false);
    const [msg, setmsg] = useState('');
    const [Success, setSuccess] = useState(false);
    const [heading, setheading] = useState('');
    const [depositLoading, setDepositLoading] = useState(false);
    const [needsBrokerage, setNeedsBrokerage] = useState(false);
    const formatter = usePriceFormatter();

    useEffect(() => {
        fetchReferralData();
        fetchDepositHistory();
    }, []);

    async function fetchDepositHistory() {
        try {
            const response = await Axios.get(UrlConstant.ReferFriend.getReferralDepositHistory);
            setDepositHistory(response.data.data);
        } catch (error) {
            console.error('Error fetching deposit history', error);
            setDepositHistory([]);
        }
    }

    async function fetchReferralData(silent: boolean = false) {
        if (!silent) {
            setLoading(true);
        }
        try {
            const response = await Axios.get<ReferralDataResponse>(
                UrlConstant.ReferFriend.ReferralData
            );
            setReferralData(response.data.data);
            setAvailableSpins(response.data.data.available_spins);
        } catch (error) {
            console.error('Error fetching referral data', error);
        } finally {
           if (!silent) {
                setLoading(false);
            }
        }
    }

    const closePopup = () => {
        setShowPopup(false);
        setNeedsBrokerage(false);
    };

    // const handleConvertToVoucher = async () => {
    //     if (referralData) {
    //         try {
    //             const payload = {
    //                 total_balance_earn_on_spin: referralData.total_balance_earn_on_spin
    //             };

    //             const response = await Axios.post(
    //                 UrlConstant.ReferFriend.createDiscountVoucher,  // API endpoint
    //                 payload
    //             );

    //             if (response.data.status) {
    //                 console.log('Voucher created successfully');
    //                 // Refresh the page after the successful API call
    //                 window.location.reload();
    //             } else {
    //                 console.error('Error creating voucher:', response.data.message);
    //             }
    //         } catch (error) {
    //             console.error('Error in voucher:', error);
    //         }
    //     }
    // };

    const handleCreateDepositRequest = async () => {
        if (!referralData) return;

        setDepositLoading(true);
        try {
            const payload = {
                total_balance_earn_on_spin: referralData.total_balance_earn_on_spin
            };
            const response = await Axios.post(
                UrlConstant.ReferFriend.createReferralDepositRequest,
                // payload
            );

            if (response.data.status) {
                setheading("Success");
                setSuccess(true);
                setmsg(response.data.message || "Your deposit request has been submitted.");
                setShowPopup(true);
                await fetchReferralData();
                await fetchDepositHistory();
            } else {
                setheading("Error");
                setSuccess(false);
                setmsg(response.data.message || "Failed to create deposit request.");
                setShowPopup(true);
            }
        } catch (error: any) {
            const errorMessage = error.response?.data?.message ?? "Failed to create deposit request.";

            if (errorMessage === "Please complete your brokerage account.") {
                setheading("Error");
                setSuccess(false);
                setmsg(errorMessage);
                setNeedsBrokerage(true);
                setShowPopup(true);
                return;
            }

            setheading("Error");
            setSuccess(false);
            setmsg(errorMessage);
            setNeedsBrokerage(false);
            setShowPopup(true);
            console.error('Error in deposit request:', error);
        } finally {
            setDepositLoading(false);
        }
    };
    // const updateAvailableSpins = async (earnedAmount: number, availableSpins: number) => {
    //     try {
    //         const response = await Axios.post(UrlConstant.ReferFriend.UpdateSpinAmount, {
    //             earnedAmount,
    //         });
    //         if (response.data.status) {
    //             setAvailableSpins(availableSpins); // Decrement available spins after spin
    //             fetchReferralData();
    //         } else {
    //             console.error('Error updating spin amount:', response.data.message);
    //         }
    //     } catch (error) {
    //         console.error('Error updating spin amount:', error);
    //     }
    // };

    const updateAvailableSpins = (earnedAmount: number, availableSpins: number) => {
        setAvailableSpins(availableSpins);
        fetchReferralData(true);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 71px - 143px)' }}>
                <CircularProgress />
            </div>
        );
    }
    if (!referralData) {
        return <Typography height='calc(100vh - 71px - 143px)'>Loading...</Typography>;
    }
    const handleCopy = (code: string) => {
        navigator.clipboard.writeText(code);
        setCopiedCoupon(code);
        setTimeout(() => {
            setCopiedCoupon(null);
        }, 3000);
    };
    return (
        <>
            <Container
                maxWidth={false}
                className="bg-color"

                style={{
                    minHeight: "calc(100vh -  71px - 143px)",
                    height: 'fit-content',
                    width: "100%",
                    overflowX: 'hidden',
                    padding: '30px !important',
                    marginBottom: '30px'


                }}
            >
                <Typography className="text-secondary" sx={{ marginBottom: "20px", paddingTop: '30px' }}>
                    <span onClick={() => navigation(-1)} style={{ color: "#4A7AF2", cursor: "pointer" }}>
                        {source === 'dashboard' ? 'Dashboard' : 'More Options'}
                    </span> / Refer a friend
                </Typography>
                {/* <Typography fontSize='24px' className='text-white' mb='10px'>Refer a Friend</Typography>
                <Box display='flex' gap='20px' mb='10px'>
                    <Box width='680px' sx={{ background: `url(${card})`, backgroundSize: '100% 99%', backgroundRepeat: 'no-repeat' }} height='auto' borderRadius='20px' padding='30px'>
                        <Typography fontSize='24px' color='#f2674a' fontWeight='800' mb='20px'>Get Started & Earn Your First Reward!</Typography>
                        <Typography fontSize='16px' className='text-secondary' mb='20px'>Create your Wolfpack account and unlock your first Free Spin.</Typography>
                        <Typography fontSize='16px' className='text-white' mb='20px' display='flex'><div>1. &nbsp;</div><div><span style={{ fontWeight: '800', textWrap: 'nowrap' }}>Sign Up to Wolfpack </span> – Create your Wolfpack account in just a few minutes.</div></Typography>

                        <Typography fontSize='16px' className='text-white' mb='20px' display='flex'><div>2. &nbsp;</div><div><span style={{ fontWeight: '800' }}> Get 1 Free Spin </span>– Once your registration is complete, you'll instantly receive one Free Spin.</div></Typography>

                        <Typography fontSize='16px' className='text-white' mb='20px' display='flex'><div>3. &nbsp;</div><div><span style={{ fontWeight: '800' }}> Complete Your Trading Account</span> – Finish Identity Verification (KYC) and activate your Trading Account.</div></Typography>

                        <Typography fontSize='16px' className='text-white' display='flex'><div>4. &nbsp;</div><div><span style={{ fontWeight: '800' }}> Claim Your Reward</span> – Submit a Deposit Request. Once approved, your reward will be credited to your Trading Wallet.</div></Typography>


                    </Box>
                    <Box width='680px' height='auto' sx={{ background: `url(${card})`, backgroundSize: '100% 99%', backgroundRepeat: 'no-repeat' }} borderRadius='20px' padding='30px' >
                        <Typography fontSize='24px' className='text-blue' fontWeight='800' mb='20px'>Refer Friends & Earn More Rewards!</Typography>
                        <Typography fontSize='16px' className='text-secondary' mb='20px'>Invite your friends and earn additional Free Spins when they complete their journey.</Typography>
                        <Typography fontSize='16px' className='text-white' mb='20px' display='flex'><div>1. &nbsp;</div><div><span style={{ fontWeight: '800' }}>Share Your Referral Code</span> – Give your unique Referral Code to your friends.</div></Typography>

                        <Typography fontSize='16px' className='text-white' mb='20px' display='flex'><div>2. &nbsp;</div><div><span style={{ fontWeight: '800' }}>Friend Signs Up</span> – Your friend creates a Wolfpack account using your Referral Code and receives their own Free Spin.</div></Typography>

                        <Typography fontSize='16px' className='text-white' mb='20px' display='flex'><div>3. &nbsp;</div><div><span style={{ fontWeight: '800' }}> Friend Activates Their Trading Account</span> – Your friend completes KYC and successfully activates their Trading Account.</div></Typography>

                        <Typography fontSize='16px' className='text-white' display='flex'><div>4. &nbsp;</div><div><span style={{ fontWeight: '800' }}> You Earn Another Free Spin</span> – Once your friend's Trading Account is activated, you'll receive an additional Free Spin. Spin the wheel and claim your next reward!</div></Typography>


                    </Box>
                </Box>
                <Typography fontSize='14px' className='text-secondary' mb='40px'>
                    Note: Free Spin rewards require an approved Deposit Request before being credited to your Trading Wallet. Deposit Requests can only be submitted after your Trading Account has been successfully activated. Rewards are promotional funds and must be used for trading before becoming eligible for withdrawal.
                </Typography> */}

                <Typography fontSize='24px' className='text-white' mb='10px'>Refer a Friend</Typography>
                <Box display='flex' gap='20px' mb='10px'>
                    <Box width='680px' sx={{ background: `url(${card})`, backgroundSize: '100% 99%', backgroundRepeat: 'no-repeat' }} height='auto' borderRadius='20px' padding='30px'>
                        <Typography fontSize='24px' color='#f2674a' fontWeight='800' mb='10px'>Spin & Win</Typography>
                        <Typography fontSize='16px' className='text-secondary' mb='20px'>Create and verify your Wolfpack account to unlock your first Signup Spin.</Typography>

                        <Box display='flex' gap='16px' mb='20px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #f2674a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>1</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>Sign Up to Wolfpack</span> — Create and verify your Wolfpack account.</Typography>
                        </Box>

                        <Box display='flex' gap='16px' mb='20px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #f2674a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>2</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>Get 1 Signup Spin</span> — Once registration is complete, one Signup Spin will be added to your account.</Typography>
                        </Box>

                        <Box display='flex' gap='16px' mb='20px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #f2674a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>3</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>Complete Your Trading Account</span> — Complete KYC and your Trading Account application, then receive approval and activation.</Typography>
                        </Box>

                        <Box display='flex' gap='16px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #f2674a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>4</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>Claim Your Reward</span> — Once your Trading Account is approved and activated, submit a Reward Claim Request. If approved, your promotional reward will be credited to your Trading Wallet.</Typography>
                        </Box>
                    </Box>

                    <Box width='680px' height='auto' sx={{ background: `url(${card})`, backgroundSize: '100% 99%', backgroundRepeat: 'no-repeat' }} borderRadius='20px' padding='30px'>
                        <Typography fontSize='24px' className='text-blue' fontWeight='800' mb='10px'>Refer & Win</Typography>
                        <Typography fontSize='16px' className='text-secondary' mb='20px'>Earn one Bonus Spin for each eligible friend who uses your Referral Code and has their Trading Account approved and activated.</Typography>

                        <Box display='flex' gap='16px' mb='20px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #4a90f2', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>1</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>Share Your Referral Code</span> — Give your unique Referral Code to your friends.</Typography>
                        </Box>

                        <Box display='flex' gap='16px' mb='20px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #4a90f2', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>2</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>Friend Signs Up</span> — Your friend creates a Wolfpack account using your Referral Code and receives their own Signup Spin.</Typography>
                        </Box>

                        <Box display='flex' gap='16px' mb='20px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #4a90f2', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>3</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>Friend Completes Their Trading Account</span> — Your friend completes KYC and their Trading Account application, then receives approval and activation.</Typography>
                        </Box>

                        <Box display='flex' gap='16px'>
                            <Box sx={{ width: '36px', height: '36px', minWidth: '36px', borderRadius: '50%', border: '1px solid #4a90f2', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontWeight: 700 }}>4</Box>
                            <Typography fontSize='16px' className='text-white'><span style={{ fontWeight: '800' }}>You Unlock a Bonus Spin</span> — Once the referral is confirmed as eligible, one Bonus Spin will be added to your account.</Typography>
                        </Box>
                    </Box>
                </Box>

                <Box display='flex' alignItems='flex-start' gap='10px' mb='40px'>
                    <InfoOutlinedIcon sx={{ fontSize: '30px', mt: '2px', color: 'grey' }} />
                    <Typography fontSize='14px' className='text-secondary'>
                        <span style={{ fontWeight: 700 }}>Note:</span> Funds displayed after a Spin are conditional promotional trading funds. Funds are credited only after Trading Account approval and an approved Reward Claim Request. Eligibility, limits, trading requirements and withdrawal conditions apply. See{' '}
                        <Link href='https://www.wolfpack.com/referandwin' target='_blank' className='text-blue' sx={{ textDecoration: 'none' }}>Terms & Conditions</Link>.
                    </Typography>
                </Box>
                <Box display='flex' gap='30px' justifyContent='space-between'>
                    <Box width='65%'>
                        <Box className='card' mb='20px' width='100%' p='30px' gap={'10px'} display='flex' flexDirection='row' justifyContent='space-between'>

                            <Box display='flex' width='fit-content' flex={1} gap='20px' >
                                <Box className='profile' padding='17px 35px' bgcolor='#4A7AF21A' fontSize='48px' textAlign='center' color='white' height='100px' width='100px' borderRadius='50px'>
                                    {referralData.referrals_count}
                                </Box>
                                <Box>
                                    <Typography className='text-white' fontSize='24px' gutterBottom>Successful Referrals</Typography>
                                    <Typography className='text-secondary' fontSize='16px'>Earn one bonus Spin for each eligible friend who signs up using your Referral Code and has their Trading Account approved and activated. Each Spin awards between $5 and $50 in promotional trading funds, subject to claim approval and Program limits</Typography>
                                </Box>
                            </Box>


                            <Box display='flex' width='fit-content' alignItems='center' gap='20px'>
                                {/* <IconButton>
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#F2674A" />
                                    <g clip-path="url(#clip0_2486_8742)">
                                        <path d="M30.333 26.6672C29.5769 26.6679 28.8323 26.8524 28.1635 27.2051C27.4947 27.5577 26.9217 28.0678 26.494 28.6912L19.985 25.7522C20.4473 24.6359 20.4491 23.3819 19.99 22.2642L26.49 19.3102C27.1239 20.227 28.0653 20.8862 29.1436 21.1683C30.2219 21.4504 31.3655 21.3367 32.3671 20.8477C33.3687 20.3588 34.1619 19.5271 34.6028 18.5035C35.0438 17.4799 35.1032 16.3321 34.7704 15.2684C34.4375 14.2047 33.7345 13.2955 32.7887 12.7058C31.843 12.1161 30.7172 11.8848 29.6155 12.054C28.5139 12.2232 27.5094 12.7817 26.7842 13.6281C26.0591 14.4744 25.6613 15.5527 25.663 16.6672C25.6672 16.931 25.694 17.194 25.743 17.4532L18.833 20.5932C18.1693 19.9715 17.3385 19.5571 16.4426 19.401C15.5466 19.2449 14.6246 19.354 13.7898 19.7147C12.955 20.0754 12.2437 20.6722 11.7434 21.4316C11.2431 22.191 10.9755 23.0801 10.9735 23.9895C10.9715 24.8989 11.2352 25.7891 11.7321 26.5507C12.2291 27.3124 12.9378 27.9122 13.771 28.2766C14.6042 28.641 15.5257 28.7541 16.4224 28.602C17.319 28.4498 18.1516 28.0391 18.818 27.4202L25.746 30.5483C25.6979 30.8073 25.6714 31.0698 25.667 31.3333C25.6668 32.2564 25.9404 33.1588 26.4531 33.9265C26.9658 34.6941 27.6947 35.2924 28.5475 35.6458C29.4004 35.9992 30.3388 36.0917 31.2442 35.9116C32.1496 35.7316 32.9813 35.2871 33.6341 34.6343C34.2868 33.9816 34.7313 33.1499 34.9114 32.2445C35.0914 31.3391 34.9989 30.4006 34.6455 29.5478C34.2922 28.695 33.6939 27.9661 32.9262 27.4534C32.1586 26.9406 31.2561 26.6671 30.333 26.6672ZM30.333 14.0002C30.8605 14 31.3763 14.1563 31.815 14.4492C32.2537 14.7422 32.5957 15.1586 32.7977 15.6459C32.9997 16.1333 33.0527 16.6695 32.9499 17.1869C32.8471 17.7044 32.5931 18.1797 32.2202 18.5527C31.8473 18.9258 31.372 19.1799 30.8547 19.2829C30.3373 19.3859 29.801 19.3332 29.3136 19.1313C28.8262 18.9295 28.4096 18.5877 28.1165 18.1491C27.8234 17.7105 27.667 17.1948 27.667 16.6672C27.6675 15.9603 27.9485 15.2823 28.4484 14.7823C28.9482 14.2823 29.626 14.001 30.333 14.0002ZM15.667 26.6672C15.1395 26.6674 14.6237 26.5112 14.185 26.2183C13.7463 25.9253 13.4043 25.5089 13.2023 25.0216C13.0003 24.5342 12.9473 23.998 13.0501 23.4806C13.1529 22.9631 13.4068 22.4878 13.7798 22.1147C14.1527 21.7417 14.6279 21.4876 15.1453 21.3846C15.6627 21.2816 16.199 21.3343 16.6864 21.5362C17.1738 21.738 17.5904 22.0798 17.8835 22.5184C18.1766 22.957 18.333 23.4727 18.333 24.0002C18.3322 24.7072 18.0511 25.3849 17.5513 25.8849C17.0516 26.3848 16.3739 26.6662 15.667 26.6672ZM30.333 34.0002C29.8055 34.0002 29.2899 33.8438 28.8513 33.5508C28.4127 33.2577 28.0709 32.8412 27.869 32.3539C27.6671 31.8665 27.6143 31.3303 27.7172 30.8129C27.8201 30.2956 28.0742 29.8204 28.4471 29.4474C28.8201 29.0744 29.2953 28.8204 29.8127 28.7175C30.33 28.6146 30.8663 28.6674 31.3536 28.8693C31.8409 29.0711 32.2575 29.413 32.5505 29.8515C32.8436 30.2901 33 30.8058 33 31.3333C32.9995 32.0404 32.7183 32.7185 32.2183 33.2185C31.7182 33.7186 31.0402 33.9997 30.333 34.0002Z" fill="#F2674A" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2486_8742">
                                            <rect width="24" height="24" fill="white" transform="translate(11 12)" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </IconButton> */}
                                <Button className='btn btn-primary' sx={{ padding: '7px 13px' }}>Available Spins: {referralData.available_spins}</Button>
                            </Box>

                        </Box>
                        <Box mb='50px' display='flex' flexDirection='row' alignItems='center' justifyContent='space-between' sx={{ background: `url(${bgimage})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }} width='100%' padding='30px'>
                            <Box width='fit-content' >
                                <Typography fontSize='20px' className='text-white'>Your Referral Code</Typography>
                                <Typography fontSize='36px' fontWeight='bold' className='text-white'>{referralData.referral_code}</Typography>
                            </Box>
                            <Button onClick={() => navigator.clipboard.writeText(referralData.referral_code)} sx={{ padding: '13px 38px', width: 'fit-content', backgroundColor: '#4A7AF2 !important' }} className='text-white btn btn-primary' >Copy Code</Button>
                        </Box>

                        <Box display='flex' flexDirection='row' alignItems='center' mb='20px' justifyContent='space-between' className='card' width='100%' padding='30px'>
                            <Typography className='text-white' fontWeight='bold' fontSize='24px'>
                                Promotional Funds Value :
                                <span style={{ color: '#4EDF6D' }}> {formatter.display(referralData.total_balance_earn_on_spin)}
                                </span>
                            </Typography>
                            {/* <Button onClick={handleConvertToVoucher} className='btn btn-primary' sx={{ padding: '7px 13px' }}>Convert to Voucher</Button> */}
                            <Button
                                onClick={handleCreateDepositRequest}
                                disabled={depositLoading}
                                className='btn btn-primary'
                                sx={{ padding: '7px 13px', minWidth: '160px' }}
                            >
                                {depositLoading ? (
                                    <CircularProgress size={20} sx={{ color: '#ffffff !important' }} />
                                ) : (
                                    'Request Deposit'
                                )}
                            </Button>
                        </Box>

                        {/* <Box className='card' width='100%' mt='20px' mb='20px' padding='30px 50px'>
                            {referralData.couponList.filter(coupon => new Date(coupon.endsAt) > new Date()).length > 0 ? (
                                referralData.couponList
                                    .filter(coupon => new Date(coupon.endsAt) > new Date())
                                    .map((coupon, index) => (
                                        <Box key={index} display='flex' alignItems='center' justifyContent='space-between' mb='30px' width='100%'>
                                            <Box>
                                                <Typography fontSize='24px' className='text-white' fontWeight='bold' gutterBottom>{coupon.code}
                                                    <Tooltip title={copiedCoupon === coupon.code ? "Copied!" : "Copy"}>
                                                        <IconButton onClick={() => handleCopy(coupon.code)} sx={{ padding: 2, marginBottom: '5px' }}>
                                                            <img src={copy} alt="Copy" width="28px" height="28px" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Typography>
                                                <Typography fontSize='16px' className='text-secondary'>Expiry: {coupon.endsAt}</Typography>
                                            </Box>
                                            <Box display='flex' gap='50px'>
                                                <Typography fontSize='36px' fontWeight='bold' color='#4EDF6D'>{formatter.display(coupon.value)}</Typography>
                                                <Button
                                                    className="btn btn-primary"
                                                    sx={{ padding: '13px 17px' }}
                                                    onClick={() => window.open('https://shop.wolfpack.com/', '_blank')}
                                                >
                                                    Redeem Coupon
                                                </Button>
                                            </Box>
                                        </Box>
                                    ))
                            ) : (
                                // <Box display='flex' flexDirection='row' alignItems='center' justifyContent='center' width='100%' padding='30px'>
                                <Typography className='text-white' fontWeight='bold' width='100%' textAlign='center' fontSize='24px'>
                                    Currently you don’t have any vouchers
                                </Typography>
                                // </Box>
                            )}
                        </Box> */}
                        {depositHistory.length > 0 && (
                            <Box className='card' width='100%' mt='20px' mb='20px' padding='30px 50px'>
                                {
                                    depositHistory.map((deposit, index) => (
                                        <Box key={deposit.transactionId}>
                                            <Box display='flex' alignItems='center' justifyContent='space-between' py='20px' width='100%'>
                                                <Box>
                                                    <Typography fontSize='20px' className='text-white' fontWeight='bold' gutterBottom>
                                                        {deposit.status === 'PENDING' && 'Deposit Pending Approval'}
                                                        {deposit.status === 'COMPLETED' && 'Deposit Successful'}
                                                        {(deposit.status === 'REJECTED' || deposit.status === 'CANCELLED') && 'Deposit Rejected'}
                                                    </Typography>
                                                    <Typography fontSize='16px' className='text-secondary'>
                                                        Requested: {new Date(deposit.requestedAt).toLocaleDateString()}
                                                    </Typography>
                                                    {deposit.status === 'COMPLETED' && deposit.completedAt && (
                                                        <Typography fontSize='14px' className='text-secondary'>
                                                            Completed: {new Date(deposit.completedAt).toLocaleDateString()}
                                                        </Typography>
                                                    )}
                                                    {(deposit.status === 'REJECTED' || deposit.status === 'CANCELLED') && deposit.rejectionReason && (
                                                        <Typography fontSize='14px' color='#F2674A'>Reason: {deposit.rejectionReason}</Typography>
                                                    )}
                                                </Box>
                                                <Typography
                                                    fontSize='28px'
                                                    fontWeight='bold'
                                                    color={deposit.status === 'COMPLETED' ? '#4EDF6D' : (deposit.status === 'REJECTED' || deposit.status === 'CANCELLED') ? '#F2674A' : '#F2C74A'}
                                                >
                                                    {formatter.display(deposit.amount)}
                                                </Typography>
                                            </Box>
                                            {index < depositHistory.length - 1 && (
                                                <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.4)' }} />
                                            )}
                                        </Box>
                                    ))
                                }
                            </Box>
                        )}

                    </Box>
                    {/* -------------------------------------------Right Side ---------------------------------------------- */}
                    <Box width={'fit-content'} height='fit-content'>

                        <Box m='auto' width='100%' height='fit-content'>
                            <Box className='card' sx={{ background: `url(${spinwheelbg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} padding='30px' minHeight='580px' height='fit-content' width='440px' border='1px solid red'>
                                <Box m='auto' width='100%' height='fit-content'>
                                    <Typography fontSize='24px' className='text-white' mb='20px'>Spin the Wheel</Typography>
                                    <Typography fontSize='16px' textAlign='center' className='text-white'>
                                        {/* {referralData.available_spins !== 0 ? `Great News! You have received a free spin. It's time to spin the wheel and receive your reward` : 'Exciting rewards are waiting! Invite your friends to join and get a chance to spin the wheel. Start inviting now!'} */}
                                        Your available Spins will appear here. New users receive one signup Spin, and you can earn one bonus Spin for each eligible referral after their Trading Account is approved and activated.
                                    </Typography>
                                    <SpinWheel isDisabled={referralData.available_spins === 0} onSpinComplete={updateAvailableSpins} fetchReferralData={fetchReferralData} />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {showPopup && (
                    <Successpopup
                        Heading={heading}
                        Success={Success}
                        onClose={closePopup}
                        Message={msg}
                        showCreateAccount={needsBrokerage}
                        onCreateAccount={() => {
                            setShowPopup(false);
                            setNeedsBrokerage(false);
                            navigation('/createapplication');
                        }}
                    />
                )}
            </Container >
        </>
    )
}

export default ReferFriend